<section class="content">
  <div class="container-fluid">
    <div class="card">
      <form (ngSubmit)="onSubmit(form)" novalidate [formGroup]="form">
        <div class="row-auto">
          <div class="col-auto">
            <label class="input">
              Mese <input type="month" formControlName="month">
            </label>
            <button class="btn btn-info ml-2" [disabled]="loading()">
              {{ loading() ? 'Caricamento...' : 'Esporta' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
